export function normalizeShapeAlias(shape) {
  const value = String(shape || '').trim().toLowerCase();
  if (value === 'round') return 'circle';
  if (value === 'hexagon') return 'hexagone';
  return value || 'rectangle';
}

export function buildShapeStyle({
  shape,
  color,
  borderColor,
  borderWidth,
  rotation,
  width,
  height,
}) {
  const normalized = normalizeShapeAlias(shape);
  const baseStyle = {
    backgroundColor: color || 'rgba(0,0,0,1)',
    transform: rotation ? `rotate(${rotation}deg)` : undefined,
    transformOrigin: 'center center',
    boxSizing: 'border-box',
  };

  if (normalized === 'circle' || normalized === 'ellipse') {
    return {
      ...baseStyle,
      borderRadius: '50%',
      border: borderWidth > 0 && borderColor ? `${borderWidth}px solid ${borderColor}` : 'none',
    };
  }

  if (normalized === 'triangle') {
    return {
      ...baseStyle,
      clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
      border: borderWidth > 0 && borderColor ? `${borderWidth}px solid ${borderColor}` : 'none',
    };
  }

  if (normalized === 'hexagone') {
    return {
      ...baseStyle,
      clipPath: 'polygon(25% 7%, 75% 7%, 100% 50%, 75% 93%, 25% 93%, 0% 50%)',
      border: borderWidth > 0 && borderColor ? `${borderWidth}px solid ${borderColor}` : 'none',
    };
  }

  if (normalized === 'star') {
    return {
      ...baseStyle,
      clipPath: 'polygon(50% 0%, 62% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 38% 35%)',
      border: borderWidth > 0 && borderColor ? `${borderWidth}px solid ${borderColor}` : 'none',
    };
  }

  if (normalized === 'arrow') {
    return {
      ...baseStyle,
      clipPath: 'polygon(0 40%, 75% 40%, 75% 20%, 100% 50%, 75% 80%, 75% 60%, 0 60%)',
      border: borderWidth > 0 && borderColor ? `${borderWidth}px solid ${borderColor}` : 'none',
    };
  }

  if (normalized === 'ring') {
    const minSize = Math.max(1, Math.min(Number(width || 0) || 0, Number(height || 0) || 0));
    const ringThickness = borderWidth > 0 ? borderWidth : Math.max(2, Math.round(minSize * 0.16));
    return {
      ...baseStyle,
      backgroundColor: 'transparent',
      borderRadius: '50%',
      border: `${ringThickness}px solid ${color || borderColor || 'rgba(0,0,0,1)'}`,
    };
  }

  // rectangle / square + fallback
  return {
    ...baseStyle,
    borderRadius: 0,
    border: borderWidth > 0 && borderColor ? `${borderWidth}px solid ${borderColor}` : 'none',
  };
}
